import { get, post } from '@/util/auth'

export type WorkflowExecution = {
  id: number
  type: string
  identifier: string
  runIdentifier: string
  status: string
  customerId: number
  assetId: number
  costObjectId: number
  created: Date
  createdBy?: null | string // Adjust type based on actual data
  activities: WorkflowExecutionActivity[]
  asset: {
    assetDescription: string
  }
}

export type WorkflowExecutionActivity = {
  id: number
  workflowParticipantTypeId: number
  workflowExecutionId: number
  requestIdentifier: string
  type: string
  description: string
  isActive: boolean
  dueDate: Date
  completedDate?: Date | null
  created: Date
  updated: Date
  createdBy?: null | string // Adjust type based on actual data
  updatedBy?: null | string // Adjust type based on actual data
  data: WorkflowExecutionActivityData[]
}

export type WorkflowExecutionActivityData = {
  id: number
  workflowExecutionActivityId: number
  key: 'LeaseExtendOptions' | string
  value: string
}

export type JSONDataValue = {
  CanReturn: boolean
  CanSelectNotInMyPoseesion: boolean
  eComPolicyIds: number[]
  Options: JSONOption[]
}

export type JSONOption = {
  OptionId: number
  NumberOfMonths: number
}

export type DataValue = {
  canReturn: boolean
  canSelectNotInMyPossession: boolean
  eComPolicyIds: number[]
  options: Option[]
}

export type Option = {
  optionId: number
  numberOfMonths: number
}

export const activityResources = {
  list: async (): Promise<WorkflowExecution[]> => {
    const res = await get<Array<WorkflowExecution>>('workflows', true)

    return res
  },
  show: async (id: number): Promise<WorkflowExecution> => {
    const res = await get<WorkflowExecution>(`workflows/${id}`, true)

    return res
  },

  makeDecision: (data: {
    workflowId: number
    type: 'return' | 'extend' | 'not_in_my_possession'
    months?: number
  }) => {
    const body = {
      type: data.type,
      months: data.months,
    }

    return post(`workflows/${data.workflowId}`, body, true)
  },
}
